<template>
  <div class="row g-4">
    <div class="col-lg-4 col-12">
      <div class="form-field"><label class="field-label">تسمية القسم</label><InputText v-model="local.label" class="w-100" /></div>
    </div>
    <div class="col-lg-4 col-12">
      <div class="form-field"><label class="field-label">العنوان</label><InputText v-model="local.title" class="w-100" /></div>
    </div>
    <div class="col-lg-4 col-12">
      <div class="form-field"><label class="field-label">الوصف الفرعي</label><InputText v-model="local.subtitle" class="w-100" /></div>
    </div>

    <div class="col-12">
      <label class="field-label d-block mb-2">الأنظمة الدراسية</label>
      <div v-for="(stage, idx) in local.stages" :key="idx" class="answer-item">
        <div class="answer-item__index">{{ idx + 1 }}</div>
        <div class="answer-item__content">
          <div class="stage-grid">
            <InputText v-model="stage.title" placeholder="الاسم" />
            <InputText v-model="stage.description" placeholder="الوصف" />
            <select v-model="stage.icon" class="accent-select">
              <option value="graduation_cap">قبعة تخرج</option>
              <option value="mosque">مسجد</option>
              <option value="award">وسام</option>
              <option value="globe">كرة أرضية</option>
            </select>
            <select v-model="stage.accent" class="accent-select">
              <option value="accent-blue">أزرق</option>
              <option value="accent-emerald">أخضر</option>
              <option value="accent-purple">بنفسجي</option>
              <option value="accent-teal">فيروزي</option>
            </select>
          </div>
          <InputText
            class="w-100 mt-2"
            :model-value="(stage.badges || []).join('، ')"
            @update:model-value="(v) => stage.badges = v.split('،').map(s => s.trim()).filter(Boolean)"
            placeholder="الشارات (افصل بفاصلة، مثال: أولى ثانوي، ثانية ثانوي)"
          />
        </div>
        <div class="answer-item__actions"><button type="button" class="answer-remove-btn" @click="local.stages.splice(idx,1)"><i class="pi pi-trash"></i></button></div>
      </div>
      <button type="button" class="add-answer-btn" v-if="local.stages.length < 8" @click="local.stages.push({ id: `stage_${Date.now()}`, title:'', description:'', badges:[], icon:'graduation_cap', accent:'accent-blue' })">
        <i class="pi pi-plus"></i> إضافة نظام دراسي
      </button>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({ modelValue: { type: Object, default: () => ({}) } });
const emit = defineEmits(['update:modelValue']);

const local = reactive({
  label: props.modelValue.label ?? '',
  title: props.modelValue.title ?? '',
  subtitle: props.modelValue.subtitle ?? '',
  stages: (props.modelValue.stages ?? []).map((s) => ({ ...s, badges: [...(s.badges ?? [])] })),
});

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });
</script>

<style scoped>
.stage-grid { display: grid; grid-template-columns: 1fr 1.5fr 130px 130px; gap: .5rem; }
.accent-select { border: 1px solid var(--border, #e5e7eb); border-radius: 8px; padding: 0 .5rem; }
</style>
